(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canspeed-home"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initProductGallery(root) {
      if (root.dataset.galleryReady === 'true') return;
      var image = root.querySelector('.product-image--selectable > img');
      var productImage = root.querySelector('.product-image--selectable');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.package-card[data-product-image]'));
      var sizeRows = Array.prototype.slice.call(root.querySelectorAll('.size-row[data-size]'));
      if (!image || !cards.length) return;

      function selectCard(card) {
        cards.forEach(function(item) {
          var selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = card.getAttribute('data-product-image');
        image.alt = 'EasyDrip Classic pen needle box, ' + card.getAttribute('data-product-label');
        if (productImage) {
          productImage.classList.remove('is-size-green', 'is-size-purple', 'is-size-orange');
          productImage.classList.add('is-size-' + card.getAttribute('data-size-color'));
        }
        sizeRows.forEach(function(row) {
          row.classList.toggle('is-selected', row.getAttribute('data-size') === card.getAttribute('data-product-label'));
        });
      }

      cards.forEach(function(card) {
        card.addEventListener('click', function() { selectCard(card); });
        card.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectCard(card);
          }
        });
      });

      root.dataset.galleryReady = 'true';
      selectCard(cards[0]);
    }

    function initNeedleMagnifiers(root) {
      root.querySelectorAll('.needle-zoom').forEach(function(zone) {
        if (zone.dataset.lensReady === 'true') return;
        var image = zone.querySelector('img');
        var lens = zone.querySelector('.needle-lens');
        if (!image || !lens) return;
        var zoom = 3.3;

        function updateLens(event) {
          var rect = zone.getBoundingClientRect();
          var x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
          var y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
          var positionX = ((x * zoom - 0.5) / (zoom - 1)) * 100;
          var positionY = ((y * zoom - 0.5) / (zoom - 1)) * 100;
          lens.style.left = (x * 100) + '%';
          lens.style.top = (y * 100) + '%';
          lens.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
          lens.style.backgroundSize = (zoom * 100) + '% ' + (zoom * 100) + '%';
          lens.style.backgroundPosition = positionX + '% ' + positionY + '%';
          lens.classList.add('is-visible');
        }

        function hideLens() { lens.classList.remove('is-visible'); }

        zone.addEventListener('pointermove', updateLens);
        zone.addEventListener('pointerleave', hideLens);
        zone.addEventListener('pointercancel', hideLens);
        zone.dataset.lensReady = 'true';
      });
    }

    function init() {
      document.querySelectorAll('#product-module').forEach(function(root) {
        initProductGallery(root);
        initNeedleMagnifiers(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canspeed-product-blister"] && !Shopify.designMode) return;
  try {
    
  function initBlisterEnquiryModals() {
    document.querySelectorAll('[data-blister-product-section]').forEach((section) => {
      if (section.dataset.enquiryModalInitialized === 'true') return;

      const modal = section.querySelector('[data-blister-enquiry-modal]');
      const closeButton = section.querySelector('[data-blister-enquiry-close]');
      const openButtons = section.querySelectorAll('[data-blister-enquiry-open]');
      if (!modal || !closeButton || openButtons.length === 0) return;

      section.dataset.enquiryModalInitialized = 'true';
      let lastTrigger = null;

      const openModal = (trigger) => {
        lastTrigger = trigger || null;
        modal.hidden = false;
        document.body.classList.add('modal-open');
        closeButton.focus();
      };

      const closeModal = () => {
        modal.hidden = true;
        document.body.classList.remove('modal-open');
        if (lastTrigger) lastTrigger.focus();
      };

      openButtons.forEach((button) => button.addEventListener('click', () => openModal(button)));
      closeButton.addEventListener('click', closeModal);
      modal.addEventListener('mousedown', (event) => {
        if (event.target === modal) closeModal();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });

      if (modal.querySelector('.form-success, .form-errors')) openModal(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlisterEnquiryModals);
  } else {
    initBlisterEnquiryModals();
  }
  document.addEventListener('shopify:section:load', initBlisterEnquiryModals);

  } catch(e) { console.error(e); }
})();
})();
